import React, { useEffect } from "react";
import { getSupportGrant, setSupportGrant } from "../../utils/supportGrant";
import { removeLocalStorageOnSignOut } from "../../hooks/General";
import Loader from "../../components/loader/Loader";

const SupportLogin = (props) => {
  useEffect(() => {
    if (getSupportGrant()) {
      window.location.replace("/");
      return;
    }

    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const token = params.get("token");

    if (!token) {
      props.history.replace("/login");
      return;
    }

    removeLocalStorageOnSignOut();
    setSupportGrant(token);
    window.location.replace("/");
  }, [props.history]);

  return <Loader />;
};

export default SupportLogin;
